import { TemplateTriviaQuestions } from "./Templates";
import { minutes, miliSeconds } from './CalcTime';

const ResumeAnswers = ()=>{
    const triviaQuestions = document.querySelector('#trivia-questions');
    const triviaResume = document.querySelector('#trivia-resume');
    const triviaResumeCtn = document.querySelector('#trivia-resume-render');
    const triviaTime = document.querySelector('.trivia-time');
    const triviaTotalTime = document.querySelector('#total-time');
    const triviaCorrectAnswers = document.querySelector('#corrects-answers');
    const SoundButton = document.querySelector('#stop-sound');
    const asnwers = JSON.parse(localStorage.getItem('answers'));
    //Validate if answers exis
    if(asnwers){
        console.log(asnwers);
        triviaQuestions.classList.add('hidden-important');
        triviaTime.classList.add('hidden');
        SoundButton.classList.add('hidden');
        triviaResume.classList.remove('hidden');
        //Render resume
        const { data, max_questions, totalcorrect, totaltime } = asnwers;
        //Set resume texts
        let segundos = miliSeconds(totaltime);
        triviaCorrectAnswers.textContent = `${totalcorrect}/${max_questions}`;
        triviaTotalTime.textContent = minutes(segundos);
        //Render answers
        data.forEach((answer, indice)=>{
            const { id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, ans, correct, respuesta_correcta } = answer;
            const template = TemplateTriviaQuestions(indice, id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, 'active', ans, correct, respuesta_correcta);
            triviaResumeCtn.append(template);
        });
    }

}

export { ResumeAnswers, miliSeconds, minutes }